window.Page = {

    slidesContainers : document.querySelectorAll('.home-category-images .home-category-events-container'),
    video            : document.querySelector('.home-events-video'),

    // Let's launch this thing
    liftoff : () => {
        Page.playPauseVideoOnClick()
        Page.interactiveSvgMap()
    },

    // Play/Pause the video on click
    playPauseVideoOnClick : () => {

        // Do nothing if we don't have a video
        if (!Page.video) return;

        Page.video.addEventListener('click' , () => {
            if (Page.video.paused) {
                Page.video.play();
            } else {
                Page.video.pause();
            }
            Page.video.parentElement.classList.toggle('playing');
        })


    },

    interactiveSvgMap : () => {

        document.querySelectorAll('.map-icon,.home-spaces-legend li').forEach(mapIcon => {

            mapIcon.addEventListener('mouseenter' , () => {

                // Grab the index
                let index = mapIcon.dataset.index;

                // Grab the related list item
                document.querySelector(`.home-spaces-legend li:nth-child(${index})`).classList.add('hovered')
                document.querySelector(`#icon-${index}`).classList.add('hovered')

            })

            mapIcon.addEventListener('mouseleave' , () => {
                document.querySelector('.home-spaces-legend li.hovered').classList.remove('hovered');
                document.querySelector('.map-icon.hovered').classList.remove('hovered')
            })

        })


    }

};

Page.liftoff()